import script from "./ErrorToast.vue?vue&type=script&lang=ts"
export * from "./ErrorToast.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__